import { Link, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'
import type { PageProps } from './types'
import { FlashMessages } from './FlashMessages'

export default function AppLayout({ children }: { children: ReactNode }) {
  const { auth, flash } = usePage<PageProps>().props

  return (
    <>
      <nav className="bg-background">
        <div className="mx-auto flex max-w-5xl items-center gap-6 px-4 py-3">
          <Link href="/search" className="text-sm font-semibold text-foreground">
            {auth.organization?.name ?? 'FindMedStaff'}
          </Link>

          <div className="flex-1" />

          <Link
            href="/search"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Search
          </Link>

          {auth.user?.is_admin && (
            <Link
              href="/admin/conflicts"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Admin
            </Link>
          )}

          {auth.user && (
            <Link
              href="/account"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Account
            </Link>
          )}
        </div>
      </nav>

      <FlashMessages flash={flash} />

      <main className="mx-auto max-w-5xl px-4 py-8">
        {children}
      </main>
    </>
  )
}
